import * as React from 'react';
import s from '../ChangePlanModal.scss';
import { useTranslation } from 'react-i18next';
import { CustomModalLayout } from 'wix-style-react';
import { ChangePlanModalComparePlans } from './ChangePlanModalCompare';
import { ChangePlanModalMessage } from './ChangePlanModalMessage';
import { ChangeDeclinePlanModalSummary } from './ChangeDeclinePlanModalSummary';

interface ChangeDeclinePlanModalBodyProps {
  handleChangePlan(): void;
  onCloseChangePlanModal(): void;
  isInGracePeriod: boolean;
}

export const ChangeDeclinePlanModalBody: React.FC<ChangeDeclinePlanModalBodyProps> = ({
  handleChangePlan,
  onCloseChangePlanModal,
  isInGracePeriod,
}) => {
  const { t } = useTranslation();
  return (
    <CustomModalLayout
      width='840px'
      title={t('change_plan.change_declined_plan_modal.title')}
      onCloseButtonClick={onCloseChangePlanModal}
      primaryButtonText={t(
        'change_plan.change_declined_plan_modal.continue_to_checkout',
      )}
      primaryButtonOnClick={handleChangePlan}
      secondaryButtonText={t('change_plan.change_plan_modal.cancel')}
      secondaryButtonOnClick={onCloseChangePlanModal}
      dataHook='change-declined-plan-modal'
    >
      <div className={s.changePlanModalLayout}>
        <ChangePlanModalComparePlans />
        <ChangeDeclinePlanModalSummary />
        <ChangePlanModalMessage />
      </div>
    </CustomModalLayout>
  );
};
